import { ArrowUp, ArrowDown, Minus } from "lucide-react";

export function Trend({ dev, showValue = true, unit = "" }) {
  if (!dev) return null;
  const color = dev.good ? "text-traffic-green" : "text-traffic-red";
  const Icon = dev.arrow === "up" ? ArrowUp : dev.arrow === "down" ? ArrowDown : Minus;
  const sign = dev.pct > 0 ? "+" : "";
  return (
    <span className={`inline-flex items-center gap-0.5 tabular-nums font-medium ${color}`} data-testid="trend">
      <Icon className="w-3.5 h-3.5" strokeWidth={3} />
      {showValue && <span>{sign}{dev.pct}%</span>}
      {unit}
    </span>
  );
}

export function ScoreBar({ label, value, dev }) {
  const good = dev ? dev.good : value >= 70;
  return (
    <div data-testid={`score-${label.toLowerCase()}`}>
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs tracking-[0.15em] uppercase font-bold text-muted-foreground">{label}</span>
        <div className="flex items-center gap-2">
          <span className="font-heading text-lg font-black tabular-nums">{value}</span>
          {dev && <Trend dev={dev} />}
        </div>
      </div>
      <div className="h-1.5 bg-surface w-full">
        <div className={`h-full ${good ? "bg-traffic-green" : "bg-traffic-red"}`} style={{ width: `${Math.min(value, 100)}%` }} />
      </div>
    </div>
  );
}

export function StatusDot({ status }) {
  return <span className={`w-2.5 h-2.5 rounded-full inline-block ${status === "green" ? "bg-traffic-green" : "bg-traffic-red"}`} data-testid={`status-dot-${status}`} />;
}
